import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaEdit, FaTrash } from "react-icons/fa";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";

const Notice = () => {
  const [form, setForm] = useState({
    title: "",
    audience: "students",
    notice_type: "general",
    color: "",
    message: "",
    active_from: "",
    active_to: "",
  });
  const [notices, setNotices] = useState([]);
  const [editId, setEditId] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const baseURL = "https://dgps.co.in/api/notice";
  const fetchURL = `${baseURL}/list`;
  const addURL = `${baseURL}/add`;
  const updateURL = `${baseURL}/update`;
  const deleteURL = `${baseURL}/delete`;

  const fetchNotices = async () => {
    try {
      const res = await axios.get(fetchURL);
      setNotices(res.data || []);
    } catch (err) {
      console.error("Error fetching notices:", err);
    }
  };

  useEffect(() => {
    fetchNotices();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { ...form };
    try {
      if (editId) {
        payload.id = editId;
        await axios.post(updateURL, payload);
      } else {
        await axios.post(addURL, payload);
      }
      setForm({
        title: "",
        audience: "students",
        notice_type: "general",
        color: "",
        message: "",
        active_from: "",
        active_to: "",
      });
      setEditId(null);
      fetchNotices();
    } catch (err) {
      console.error("Error saving notice", err);
    }
  };

  const handleEdit = (item) => {
    setForm({
      title: item.title,
      audience: item.audience,
      notice_type: item.notice_type,
      message: item.message,
      active_from: item.active_from,
      active_to: item.active_to,
    });
    setEditId(item.id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this notice?")) return;
    try {
      await axios.post(deleteURL, { id });
      fetchNotices();
    } catch (err) {
      console.error("Delete error", err);
    }
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <div style={{ flex: 1, backgroundColor: "#f4f6f8" }}>
        <main style={{ padding: "30px", maxWidth: "1000px", margin: "auto", marginTop: "0px", }}>
          {/* Add/Edit Notice Section */}
          <section style={cardStyle }>
            <h2 style={titleStyle}>
              {editId ? "✏️ Edit Notice" : "➕ Add New Notice"}
            </h2>
            <form onSubmit={handleSubmit}>
            <div style={formGrid}>
                <FormGroup label="Notice Title">
                <input
                    type="text"
                    name="title"
                    value={form.title}
                    onChange={handleChange}
                    style={fullWidthInput}
                    required
                />
                </FormGroup>

                <FormGroup label="Audience">
                <select
                    name="audience"
                    value={form.audience}
                    onChange={handleChange}
                    style={fullWidthInput}
                >
                    <option value="students">Students</option>
                    <option value="parents">Parents</option>
                    <option value="teachers">Teachers</option>
                    <option value="all">All</option>
                </select>
                </FormGroup>

                <FormGroup label="Notice Type">
                <select
                    name="notice_type"
                    value={form.notice_type}
                    onChange={handleChange}
                    style={fullWidthInput}
                >
                    <option value="general">General</option>
                    <option value="exam">Exam</option>
                    <option value="meeting">Meeting</option>
                    <option value="holiday">Holiday</option>
                    <option value="fee">Fee</option>
                </select>
                </FormGroup>

                <FormGroup label="Notice Color">
                <select
                    name="color"
                    value={form.color || ""}
                    onChange={handleChange}
                    style={fullWidthInput}
                >
                    <option value="">Select Color</option>
                    <option value="primary">Primary</option>
                    <option value="success">Success</option>
                    <option value="info">Info</option>
                    <option value="warning">Warning</option>
                    <option value="danger">Danger</option>
                </select>
                </FormGroup>

                <FormGroup label="Message" style={{ gridColumn: "1 / -1" }}>
                <textarea
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    rows="4"
                    placeholder="Write your message..."
                    style={fullWidthInput}
                    required
                />
                </FormGroup>

                <FormGroup label="Active From">
                <input
                    type="date"
                    name="active_from"
                    value={form.active_from}
                    onChange={handleChange}
                    style={fullWidthInput}
                    required
                />
                </FormGroup>

                <FormGroup label="Active To">
                <input
                    type="date"
                    name="active_to"
                    value={form.active_to}
                    onChange={handleChange}
                    style={fullWidthInput}
                    required
                />
                </FormGroup>
            </div>

            <div style={{ textAlign: "right", marginTop: "20px" }}>
                <button type="submit" style={buttonStyle}>
                {editId ? "Update Notice" : "Add Notice"}
                </button>
            </div>
            </form>
          </section>
            {/* View Notices Section */}
            <section style={cardStyle}>
            <h2 style={titleStyle}>📋 All Notices</h2>
            {notices.length === 0 ? (
                <p>No notices found.</p>
            ) : (
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {notices.map((item) => {
                    const colorMap = {
                    primary: "#e0f0ff",
                    success: "#e6f4ea",
                    info: "#eaf7ff",
                    warning: "#fff8e1",
                    danger: "#ffeaea",
                    };

                    const bgColor = colorMap[item.color] || "#f9f9f9";

                    return (
                    <li
                        key={item.id}
                        style={{
                        marginBottom: "15px",
                        padding: "15px",
                        borderRadius: "8px",
                        background: bgColor,
                        display: "flex",
                        flexDirection: "column",
                        }}
                    >
                        <strong style={{ fontSize: "16px", color: "#333" }}>{item.title}</strong>
                        <small style={{ color: "#777" }}>
                        Type: {item.notice_type} | Audience: {item.audience}
                        </small>
                        <div style={{ marginTop: "6px" }}>{item.message}</div>
                        <small style={{ color: "#666", marginTop: "4px" }}>
                        Active: {item.active_from} to {item.active_to}
                        </small>
                        <div style={{ textAlign: "right", marginTop: "10px" }}>
                        <FaEdit
                            onClick={() => handleEdit(item)}
                            style={{
                            color: "#0077cc",
                            cursor: "pointer",
                            marginRight: "15px",
                            }}
                        />
                        <FaTrash
                            onClick={() => handleDelete(item.id)}
                            style={{ color: "red", cursor: "pointer" }}
                        />
                        </div>
                    </li>
                    );
                })}
                </ul>
            )}
            </section>

        </main>
      </div>
    </div>
  );
};

// Reusable Form Group
const formGrid = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "20px",
};

const fullWidthInput = {
  width: "100%",
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "15px",
  boxSizing: "border-box",
};

const FormGroup = ({ label, children, style }) => (
  <div style={{ ...style }}>
    <label
      style={{
        marginBottom: "6px",
        display: "block",
        fontWeight: 500,
        color: "#444",
      }}
    >
      {label}
    </label>
    {children}
  </div>
);


const buttonStyle = {
  padding: "10px 25px",
  backgroundColor: "#0077cc",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  fontSize: "15px",
  cursor: "pointer",
};

const cardStyle = {
  background: "#ffffff",
  padding: "25px",
  borderRadius: "12px",
  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
  marginBottom: "30px",
  
};

const titleStyle = {
  color: "#0077cc",
  marginBottom: "25px",
};

const listItemStyle = {
  marginBottom: "15px",
  padding: "15px",
  borderRadius: "8px",
  background: "#f9f9f9",
  display: "flex",
  flexDirection: "column",
};

export default Notice;
